// Default messages for `FileUploadError` reasons and design-system file input
// errors. Keys are the reason or error type, so a consumer can override any of
// them through `getUploadErrorMessage`.
export default {
  NETWORK: {
    id: 'file_uploader_error_network',
    defaultMessage:
      'The file could not reach our servers. Check your connection, then try again.',
  },
  FORBIDDEN: {
    id: 'file_uploader_error_forbidden',
    defaultMessage:
      'You are not allowed to upload this file. Ask your administrator for access.',
  },
  UPLOAD_DISABLED: {
    id: 'file_uploader_error_upload_disabled',
    defaultMessage: 'File upload is temporarily unavailable. Try again later.',
  },
  UNKNOWN_USE_CASE: {
    id: 'file_uploader_error_unknown_use_case',
    defaultMessage:
      'File upload is not available here. Contact support if the problem persists.',
  },
  INVALID_FILE: {
    id: 'file_uploader_error_invalid_file',
    defaultMessage:
      'This file type is not accepted. Choose a file in an accepted format, then try again.',
  },
  EMPTY_FILE: {
    id: 'file_uploader_error_empty_file',
    defaultMessage: 'This file is empty. Choose another file, then try again.',
  },
  FILE_TOO_LARGE: {
    id: 'file_uploader_error_file_too_large',
    defaultMessage:
      'This file is too large. Choose a smaller file, then try again.',
  },
  SIGNATURE_REJECTED: {
    id: 'file_uploader_error_signature_rejected',
    defaultMessage: 'The upload session expired. Try again.',
  },
  ROUTE_UNAVAILABLE: {
    id: 'file_uploader_error_route_unavailable',
    defaultMessage:
      'The file could not be attached. Contact support if the problem persists.',
  },
  INVALID_REQUEST: {
    id: 'file_uploader_error_invalid_request',
    defaultMessage:
      'The file could not be attached. Contact support if the problem persists.',
  },
  SERVICE: {
    id: 'file_uploader_error_service',
    defaultMessage: 'The file could not be uploaded. Try again later.',
  },
  WRONG_FILE_EXTENSION: {
    id: 'file_uploader_input_error_wrong_file_extension',
    defaultMessage:
      'This file type is not accepted. Choose a file in an accepted format.',
  },
  MAX_FILE_SIZE_EXCEEDED: {
    id: 'file_uploader_input_error_max_file_size_exceeded',
    defaultMessage: 'This file is too large. Choose a smaller file.',
  },
  MAX_FILES_EXCEEDED: {
    id: 'file_uploader_input_error_max_files_exceeded',
    defaultMessage: 'Too many files selected. Remove some files.',
  },
  MAX_FILES_SIZE_EXCEEDED: {
    id: 'file_uploader_input_error_max_files_size_exceeded',
    defaultMessage:
      'The selected files are too large together. Remove some files.',
  },
  MIN_FILE_SIZE_NOT_EXCEEDED: {
    id: 'file_uploader_input_error_min_file_size_not_exceeded',
    defaultMessage: 'This file is too small. Choose another file.',
  },
}
